import { render, staticRenderFns } from "./xunfangtongji.vue?vue&type=template&id=6aedddf6&scoped=true"
import script from "./xunfangtongji.vue?vue&type=script&lang=js"
export * from "./xunfangtongji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedddf6",
  null
  
)

export default component.exports